<template>
	<div class="collapse tabbed">
		<div class="collapse-selection-container">

			<!-- Mobile: Using select for item selection -->
			<div class="collapse-selection-compact">
				<select @change="currentItemIndex = Number($event.target.value)">
					<option
							v-for="(item, index) in collapseItems"
							:key="item.title"
							:value="index">
						{{ item.title }}
					</option>
				</select>
			</div>


			<div class="collapse-selection">
				<div
						v-for="(item, index) in collapseItems"
						:key="item.title"
						class="collapse-selector"
						:class="{ 'active': currentItemIndex === index }">
					<div class="card-layout card-content" @click="currentItemIndex = index">
						{{ item.title }}
					</div>
				</div>
			</div>
		</div>

		<div class="collapse-item-content-wrapper">
			<slot></slot>
		</div>

	</div>
</template>

<script>
export default {
	props: {
		items: {
			type: String
		}
	},
	watch: {
		currentItemIndex(val) {
			this.$eventHub.$emit('updateTabItemIndex', val);
		}
	},
	data() {
		return {
			collapseItems: JSON.parse(this.items) ?? {},
			currentItemIndex: 0
		};
	}
};
</script>
